import React, {Component} from 'react';
import {Button, Row, Col, notification} from 'antd';
import auth from '@source/utils/auth';
import axios from 'axios';

import {getIntoObject} from '../../../../../../helpers';
import {Order} from '../../../../../../interfaces';

interface Properties {
  orderData: Order;
}

class Contract extends Component<Properties> {
  render() {
    return (
      <Row style={{textAlign: 'center', padding: '20px 0'}}>
        <Col span={24}>
          <Button
            onClick={() => {
              const membership = getIntoObject(this.props.orderData, ['order', 'prospect', 'personExternalId']);
              const date = getIntoObject(this.props.orderData, ['createdAt']);
              const reference = getIntoObject(this.props.orderData, ['reference']);
              if (membership && date) {
                axios
                  .get(`${process.env.RESTAPI_URL}/holmesplace/api/backoffice/contract/fallback`, {
                    params: {membership, date: new Date(Number(date)).getTime(), reference},
                    headers: {authorization: `Bearer ${auth.getAccessToken()}`}
                  })
                  .then(response => response.data)
                  .then(file => {
                    const fileUrl = `${process.env.RESTAPI_URL}/holmesplace/api/backoffice/contract/download/${file}`;
                    const a = document.createElement('A') as HTMLAnchorElement;
                    a.href = fileUrl;
                    a.download = file;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                  })
                  .catch(err => {
                    notification.error({
                      message: 'Error',
                      description: err.response.data
                    });
                  });
              }
            }}
          >
            {'Get contract'}
          </Button>
        </Col>
      </Row>
    );
  }
}

export default Contract;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/Contract/Contract.tsx